// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 公共数据=================================
import * as publicData from './utils/publicData'
import * as util from './utils/util'
import * as theoneCommon from './plugin/theone/theoneCommon'
import * as theoneActivity from './plugin/theone/theoneActivity'

import * as androidNative from './utils/androidNative'

// vant=================================
import Vant from 'vant'
import 'vant/lib/index.css'


// swiper轮播=================================
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

Vue.use(Vant);
// vant组件=================================

Vue.prototype.$publicData = publicData.publicData
Vue.prototype.$util = util.utils
Vue.prototype.$TheoneCommon = theoneCommon.theoneCommon
Vue.prototype.$TheoneActivity = theoneActivity.theoneActivity

Vue.prototype.$AndroidNative = androidNative.AndroidNative


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js